import Vue from 'vue'

const isMobile = {}

isMobile.install = function (Vue) {
  Vue.prototype.$mobile = window.innerWidth < 768
}

Vue.use(isMobile)
